import React, {FC, PropsWithChildren} from 'react';
import Modal from 'react-modal';
import {generalPopupStyles} from '../../../constants/popupStyles';
import Spinner from '../Spinner';

Modal.setAppElement(document.getElementById('root'));

type PopupProps = PropsWithChildren<{
  isOpen: boolean,
  isLoading?: boolean,
  closeModal: () => void,
  shouldCloseOnOverlayClick?: boolean,
  contentLabel?: string,
  popupStyles?: object,
}>

const Popup: FC<PopupProps> = ({
  isOpen,
  closeModal,
  shouldCloseOnOverlayClick = true,
  isLoading = false,
  contentLabel = '',
  children,
  popupStyles = generalPopupStyles
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel={contentLabel}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      style={popupStyles}
    >
      {isLoading ? <Spinner /> : children}
    </Modal>
  );
};

export default Popup;
